import { buildProps } from '../../../../utils/vue/props/runtime.mjs';
import { componentSizes } from '../../../../constants/size.mjs';

const paginationJumperProps = buildProps({
  size: {
    type: String,
    values: componentSizes
  }
});

export { paginationJumperProps };
//# sourceMappingURL=jumper2.mjs.map
